'use client';

import type { ApolloError } from '@apollo/client/errors';

import { ErrorPid } from '@/shared/pid/components';
import HeaderRedirectButtons from '@/shared/pid/components/DetailOrRecorTracking/HeaderRedirectButtons';

export default function ErrorView({
  error,
  reset,
}: {
  error: ApolloError | string;
  reset: () => void;
}) {
  return (
    <div className=" tw-bg-neutral-light-200 tw-w-full tw-h-[100vh]">
      <div className="tw-w-full tw-px-4.8  tw-pt-[2.6rem]">
        <HeaderRedirectButtons />
      </div>
      <div className="tw-w-full tw-h-[100vh]  tw-py-3.6 tw-px-4.8 tw-bg-neutral-light-200">
        <div className="tw-w-full tw-h-[70vh]">
          <ErrorPid error={error} reset={() => reset()} />
        </div>
      </div>
    </div>
  );
}
